import { toast, ToastOptions } from 'react-toastify';
import { severityType } from './types';
import { Alert, Typography } from '@components/base';

interface IToastType {
  message: unknown;
  severity?: severityType;
  dismissible?: boolean;
  showIcon?: boolean;
  title?: unknown;
}

const getSafeText = (value: unknown, fallback = '') => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (Array.isArray(value)) {
    return value
      .map((item) => (typeof item === 'string' ? item : String(item)))
      .filter(Boolean)
      .join(', ');
  }
  if (value && typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch (error: unknown) {
      return fallback;
    }
  }
  return fallback;
};

function notify(data: IToastType, options?: ToastOptions) {
  const { message, severity = 'success', dismissible = true, showIcon = true, title } = data;
  const safeMessage = getSafeText(message, 'Something went wrong');
  const safeTitle = getSafeText(title);
  toast(({ closeToast }) => {
    return (
      <Alert
        icon={showIcon}
        severity={severity}
        onClose={dismissible ? closeToast : undefined}
        title={safeTitle}
      >
        <Typography variant="inherit">{safeMessage}</Typography>
      </Alert>
    );
  }, options);
}

export default notify;
